/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".payment-method-form[_ngcontent-%COMP%]   mat-radio-group[_ngcontent-%COMP%] {\n  padding-left: 16px; }\n\n.payment-method-form[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  -ms-grid-row-align: center;\n      align-self: center; }\n\n.payment-method-form[_ngcontent-%COMP%]   mat-error[_ngcontent-%COMP%] {\n  display: block;\n  padding: 4px 0 0 40px;\n  letter-spacing: 0.4px;\n  color: color-red; }\n\n.payment-method-form[_ngcontent-%COMP%]   .add-button-text[_ngcontent-%COMP%] {\n  padding-left: 4px;\n  position: relative;\n  top: 1px; }"];
export { styles as styles };
